module.exports = __webpack_public_path__ + "static/media/ecomShop.8af76be7.png";